// in development:
// import { logState } from '../../../shared/helpers/log_State'
import setCookie from '../shared/helpers/cookie'
import { getSessionStorageItem, setSessionStorageItem } from '../shared/helpers/sessionStorage'

const cachedNonstandardUser = getSessionStorageItem('nonstandardUser')

const cachedCountry = getSessionStorageItem('customCountry')

const DSCInitialState = {
  header: null, // passing null shows the header by default
  footer: null, // passing null shows the footer by default
  initalHeader: null,
  initalFooter: null,
  appLayout: {
    fullWidth: true,
  },
  hasSetToStationOrKiosk: false,
  customCountry: cachedCountry ?? null,
  nonstandardUser: cachedNonstandardUser ?? {
    firstName: '',
    lastName: '',
    displayName: '',
    birthYear: null,
    genderType: 'unknown',
    initialized: false,
    languageRegion: '',
    authenticated: false,
    azureSessionId: null,
    atn: 1,
  },
}

const DSCReducer = (state, action) => {
  const change = { ...state }
  switch (action.type) {
    case 'UPDATE_LANGUAGE': {
      const countryLang = action?.data?.countryLang?.value?.split('_')
      setCookie('fslanguage', countryLang?.[1] ?? 'en')
      change.customCountry = countryLang?.[0] ?? 'us'
      setSessionStorageItem({ customCountry: change.customCountry })
      break
    }
    case 'CLEAR_NONSTANDARD_USER': {
      Object.assign(change, { nonstandardUser: { initialized: false } })
      setSessionStorageItem(change)
      break
    }
    case 'POPULATE_SIMPLE_NONSTANDARD_USER': {
      action.data.nonstandardUser.initialized = true
      Object.assign(change, action.data)
      setSessionStorageItem(change)
      break
    }
    case 'POPULATE_NONSTANDARD_USER': {
      action.data.nonstandardUser.initialized = true
      action.data.nonstandardUser.genderType = 'unknown'
      action.data.nonstandardUser.displayName = `${action.data.nonstandardUser.firstName} ${action.data.nonstandardUser.lastName}`
      action.data.nonstandardUser.authenticated = action.data.nonstandardUser?.authenticated
      action.data.nonstandardUser.atn = 1
      const countryLang = action?.data?.nonstandardUser?.languageRegion?.value?.split('_')
      if (countryLang) {
        change.customCountry = countryLang?.[0] ?? 'us'
        setCookie('fslanguage', countryLang?.[1] ?? 'en')
        setSessionStorageItem({ customCountry: change.customCountry })
      }
      Object.assign(change, action.data)
      setSessionStorageItem(change)
      setSessionStorageItem({ redirectToGuestPage: true })
      setSessionStorageItem({ guestTree: [action.data.nonstandardUser] })
      break
    }
    case 'SET_HEADER_FOOTER': {
      change.header = { ...action.data.header }
      change.footer = { ...action.data.footer }
      change.initalHeader = { ...action.data.header }
      change.initialFooter = { ...action.data.footer }
      break
    }
    case 'SET_STATION_MODE': {
      change.header = { ...action.data.header }
      change.footer = { ...action.data.footer }
      change.appLayout = { ...action.data.appLayout }
      change.hasSetToStationOrKiosk = true
      break
    }
    case 'SET_APPLAYOUT': {
      change.appLayout = { ...action.data.appLayout }
      break
    }
    default: {
      console.error(`ERROR: Unhandled action type: ${action.type}`) // eslint-disable-line
    }
  }

  // uncomment the following line during devleopment
  // logState(action, state, change)

  return { ...change }
}

export { DSCInitialState, DSCReducer }
